import orderBy from "lodash/orderBy";
import { arrayCount } from "@/js/utils";

export class AllAreaTranslator {
  // all_areaからのレスポンスを市町村へ変換する
  static toMunicipalities = data => {
    // レスポンスの値が存在しない場合、空配列を返す
    if (!AllAreaTranslator.hasResults(data)) {
      return [];
    }

    // 返り値の変数を定義
    const municipalities = [];

    // レスポンスのresult（都道府県）をdisp_noでソート
    const sortedPrefectures = AllAreaTranslator.sort(data.results);

    sortedPrefectures.forEach(prefecture => {
      // 市町村をdisp_noでソート
      const sortedMunicipalities = AllAreaTranslator.sort(
        prefecture.municipalities
      );
      sortedMunicipalities.forEach(municipality => {
        // disp_flgが"0"でなければ次の市町村へ
        if (municipality.disp_flg === "1") {
          return;
        }
        // 以下の要素を返り値として追加する
        // value:市町村コード
        // text:市町村名
        municipalities.push({
          value: municipality.municip_code,
          text: municipality.municip_name,
          controlled_area: municipality.controlled_area
        });
      });
    });

    return municipalities;
  };

  // all_areaからのレスポンスを地域へ変換する
  static toAreas = data => {
    // レスポンスの値が存在しない場合、空配列を返す
    if (!AllAreaTranslator.hasResults(data)) {
      return [];
    }

    // 返り値の変数を定義
    const areas = [];

    // レスポンスのresult（都道府県）をdisp_noでソート
    const sortedPrefectures = AllAreaTranslator.sort(data.results);

    sortedPrefectures.forEach(prefecture => {
      // 市町村をdisp_noでソート
      const sortedMunicipalities = AllAreaTranslator.sort(
        prefecture.municipalities
      );

      sortedMunicipalities.forEach(municipality => {
        // disp_flgが"0"でなければ次の市町村へ
        if (municipality.disp_flg === "1") {
          return;
        }

        municipality.cvr_areas.forEach(cvrArea => {
          // 地域をdisp_noでソート
          const sortedAreas = AllAreaTranslator.sort(cvrArea.areas);

          sortedAreas.forEach(area => {
            // disp_flgが"0"でなければ次の地域へ
            if (area.disp_flg === "1") {
              return;
            }
            // 以下の要素を返り値として追加する
            // municipality:地域に紐づく市町村コード
            // value:地域コード
            // text:市域名
            areas.push({
              municipality: municipality.municip_code,
              value: area.area_code,
              text: area.area_name
            });
          });
        });
      });
    });

    return areas;
  };

  // all_areaからのレスポンスを都道府県へ変換する
  static toPrefectures = data => {
    // レスポンスの値が存在しない場合、空配列を返す
    if (!AllAreaTranslator.hasResults(data)) {
      return [];
    }

    // レスポンスのresult（都道府県）をdisp_noでソート
    const sortedPrefectures = AllAreaTranslator.sort(data.results);

    // 以下の要素を返り値として追加する
    // value:都道府県コード
    // text:都道府県名
    // disp_no:都道府県の表示順
    const prefectures = sortedPrefectures.map(prefecture => {
      return {
        value: prefecture.pref_code,
        text: prefecture.pref_name,
        disp_no: prefecture.disp_no
      };
    });

    return prefectures;
  };

  // 指定した市町村に属する地域のリストを返す
  // areas: 元となる地域リスト
  // municipality: 指定地域
  static toAreasByMunicipality = (areas, municipality) => {
    if (arrayCount(areas) > 0) {
      return areas.filter(area => area.municipality === municipality);
    }
    return [];
  };

  // 渡されたリストをdisp_noでソートする
  static sort = list => {
    list.forEach(data => {
      data.disp_no = Number(data.disp_no);
    });
    return orderBy(list, ["disp_no"]);
  };

  // 値を持っているかを確認する
  static hasResults = data => {
    return data && data.results;
  };
}
